import * as z from "zod"

import { createEntityFor } from "@axtesys/react-tools"

export type HobexResponse = {
  acquirer: string
  actionCode: string
  amount: number
  applicationIdentifier: string
  authCode: string
  brand: string
  cardNumber: string
  clientId: string
  connectionStatus: string
  countryCode?: string
  currency: string
  cvm: string
  expiry: string
  foreignAmount: number
  host: string
  isContactless: boolean
  isOk: boolean
  isSignature: boolean
  language: string
  macAddress: string
  merchantName: string
  networkMedia: string
  operator: string
  packageVersion: string
  pan: string
  receiptNo: string
  reference: string
  responseCode: string
  responseText: string
  serialNo: string
  serviceCode: string
  stan: string
  swVersion: string
  terminal: string
  terminalGateway: string
  terminalID: string
  terminalIpAddress: string
  terminalSubnetMask: string
  tipAmount: number
  transactionCount: number
  transactionDate: string
  transactionId: string
  transactionType: string
  vu: string
}

export type HobexReceiptData = {
  transactionId?: string
  transactionDate?: string
  currency?: string
  amount?: number
  tipAmount?: number
  receiptNo?: string
  terminalID?: string
  brand?: string
  pan?: string
  transactionType?: string
  responseCode?: string
}

export const HobexReceiptDataEntity = createEntityFor<HobexReceiptData>()
  .withSchema(
    z.object({
      transactionId: z.ostring(),
      transactionDate: z.ostring(),
      currency: z.ostring(),
      amount: z.onumber(),
      tipAmount: z.onumber(),
      receiptNo: z.ostring(),
      terminalID: z.ostring(),
      brand: z.ostring(),
      pan: z.ostring(),
      transactionType: z.ostring(),
      responseCode: z.ostring(),
    }),
  )
  .serialize(data => data)
  .deserialize(json => json)
